export default __webpack_public_path__ + "static/media/catlist_img1.b3e6b67c.png";